import { api } from 'domains/api';
import { BASE_ANONYMOUS_API_ROUTES, getBaseAPIRoute } from 'domains/api/base/routes';
import { Schedule } from './types';

export const getSchedule = (clientId: string, scheduleId: string): Promise<Schedule> => {
  return api.baseAnonymous.get<Schedule>(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients[':clientId']['pending-schedules'][':scheduleId'].get, {
      scheduleId,
      clientId,
    }),
  );
};

export type SchedulePendingScheduleDto = {
  dateTime: string;
  timeZone: string;
  calendarID: number;
};

export const schedulePendingSchedule = (
  clientId: string,
  scheduleId: string,
  payload: SchedulePendingScheduleDto,
): Promise<Schedule> => {
  return api.baseAnonymous.post(
    getBaseAPIRoute(BASE_ANONYMOUS_API_ROUTES.clients[':clientId']['pending-schedules'][':scheduleId'].schedule, {
      scheduleId,
      clientId,
    }),
    payload,
  );
};
